import Hashids from 'hashids';
import sha256 from 'js-sha256';
import QRCode from 'qrcode';

const PLATFORM_NAME = 'gladius_art';

export function generateCertificateQrData({
  certificateId,
  certificateCode,
  editionId,
  order = 1,
  totalCode = 1,
}) {
  const hashids = new Hashids();
  const encodedId = hashids.encode(certificateId);
  const codePart = String(certificateCode);
  const hash = sha256.create();
  hash.update(codePart);
  hash.update(encodedId);
  const hashedCode = hash.hex();
  return {
    platform: PLATFORM_NAME,
    edition_id: editionId,
    order,
    total_code: totalCode,
    code: hashedCode,
  };
}

export async function generateCertificateQrCodeImage(qrData, opts = {}) {
  const json = JSON.stringify(qrData);
  return QRCode.toDataURL(json, {
    errorCorrectionLevel: 'L',
    width: opts.size || 450,
    margin: 2,
    ...opts,
  });
}
